import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Dropdown } from 'ui-components/components/INTERNAL/dropdown';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import { itemGroupByOptions, GroupByOptionToFriendlyNameMap } from './constants';

import { messages } from './messages';

import style from './grouped-order-items.module.less';

export const GroupItemsBySelector = ({ userSettingGroupItemsBy, setUserSettingGroupItemsBy }) => {
  const updateGroupItemsBy = useCallback(
    (newGroupByValue) => {
      setUserSettingGroupItemsBy(newGroupByValue);
    },
    [setUserSettingGroupItemsBy],
  );
  return (
    <Dropdown className={style['group-by-selector-dropdown']} menuPosition='bottom-left'>
      <DropdownMenuToggler className={style['group-by-selector']} hideChevron theme='unstyled'>
        <FontAwesomeIcon className={style['group-items-by-toggler']} icon={faGear} />
      </DropdownMenuToggler>
      <div className={style}>
        <div className={style['options-content']}>
          <div className={style['options-title']}>
            <FormattedMessage {...messages.groupByLabel} />
          </div>
          <RadioCheckList className={style.options}>
            {itemGroupByOptions.map((option) => {
              const isChecked = userSettingGroupItemsBy === option;
              const optionName = GroupByOptionToFriendlyNameMap[option];
              return (
                <div key={option} className={style.option} onClick={() => updateGroupItemsBy(option)}>
                  <RadioCheckListItem key={option} isChecked={isChecked} onChecked={() => updateGroupItemsBy(option)}>
                    {optionName}
                  </RadioCheckListItem>
                </div>
              );
            })}
          </RadioCheckList>
        </div>
      </div>
    </Dropdown>
  );
};

GroupItemsBySelector.propTypes = {
  userSettingGroupItemsBy: PropTypes.oneOf(itemGroupByOptions).isRequired,
  setUserSettingGroupItemsBy: PropTypes.func.isRequired,
};
